import TestimonialVideoPlayer from "@/components/landing/TestimonialVideoPlayer";
import { TESTIMONIALS } from "@/data/testimonials";

/**
 * Sección de testimonio destacado en la Home — se ubica después de "El cambio"
 * (BeforeAfter). Muestra el primer testimonio de TESTIMONIALS (video + nombre
 * grande + las 4 quotes), sin link de salida a /testimonios-eos ya que hoy esa
 * página no tiene más contenido que este mismo testimonio.
 */
export default function TestimonialShowcase({ cta }) {
  const testimonial = TESTIMONIALS[0];
  if (!testimonial) return null;

  return (
    <section data-testid="home-testimonial-section" className="section-padding bg-white">
      <div className="container-eos">
        <div className="max-w-3xl reveal">
          <span className="eyebrow">Testimonios</span>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-navy-800 leading-tight">
            Resultados reales, en palabras de{" "}
            <span className="text-[#F26522]">quienes los vivieron.</span>
          </h2>
        </div>

        <div className="mt-12 grid lg:grid-cols-12 gap-8 lg:gap-10 items-center">
          <div className="reveal lg:col-span-3">
            <TestimonialVideoPlayer videoId={testimonial.videoId} posterImage={testimonial.poster} name={testimonial.name} />
          </div>

          <div className="reveal lg:col-span-9" style={{ transitionDelay: "100ms" }}>
            <p className="font-display font-extrabold text-2xl sm:text-3xl text-navy-800" data-testid="home-testimonial-name">
              {testimonial.name}
            </p>
            <p className="mt-1 text-sm sm:text-base text-slate-500">
              {testimonial.role}
              {testimonial.company && (
                <>
                  {" "}·{" "}
                  <span className="text-[#F26522] font-semibold">{testimonial.company}</span>
                </>
              )}
            </p>

            <blockquote data-testid="home-testimonial-quote-1" className="mt-6 flex gap-3 border-l-4 border-[#F26522] pl-5">
              <p className="font-display font-extrabold text-navy-800 leading-tight text-2xl sm:text-3xl lg:text-4xl">
                “{testimonial.quotes[0]}”
              </p>
            </blockquote>

            <div className="mt-6 space-y-3 pl-6">
              {testimonial.quotes.slice(1).map((q, i) => (
                <blockquote key={i} data-testid={`home-testimonial-quote-${i + 2}`}>
                  <p className="text-slate-500 leading-relaxed text-sm sm:text-base">
                    “{q}”
                  </p>
                </blockquote>
              ))}
            </div>

            {cta && <div className="mt-7">{cta}</div>}
          </div>
        </div>
      </div>
    </section>
  );
}
